import { http } from '@/http'

/**
 * Alquiler de vehículos: pagos y contratos (DEF-ADM-015 Fase 4).
 * El header X-City-Id lo agrega el interceptor global.
 */
export default {
  // Dashboard: solo vehículos RENTED, estado de pago + alerta de contrato.
  status() {
    return http.get('/api/v1/fleet/rentals/status')
  },
  // Pagos de un vehículo.
  listPayments(vehicleId, params) {
    return http.get(`/api/v1/fleet/rentals/${vehicleId}/payments`, { params })
  },
  createPayment(vehicleId, data) {
    return http.post(`/api/v1/fleet/rentals/${vehicleId}/payments`, data)
  },
  getPayment(id) {
    return http.get(`/api/v1/fleet/rentals/payments/${id}`)
  },
  updatePayment(id, data) {
    return http.put(`/api/v1/fleet/rentals/payments/${id}`, data)
  },
  removePayment(id) {
    return http.delete(`/api/v1/fleet/rentals/payments/${id}`)
  },
  uploadProof(id, file) {
    const fd = new FormData()
    fd.append('photo', file)
    return http.post(`/api/v1/fleet/rentals/payments/${id}/proof`, fd)
  },
  getProof(id) {
    return http.get(`/api/v1/fleet/rentals/payments/${id}/proof`)
  },
  // Contrato del vehículo (PDF/imagen).
  uploadContract(vehicleId, file) {
    const fd = new FormData()
    fd.append('file', file)
    return http.post(`/api/v1/fleet/rentals/${vehicleId}/contract`, fd)
  },
  getContract(vehicleId) {
    return http.get(`/api/v1/fleet/rentals/${vehicleId}/contract`)
  }
}
